import { createReducer } from 'redux-act';

import {
  CHILD_CATEGORY_FETCH_INIT, CHILD_CATEGORY_FETCH_SUCCESS, CHILD_CATEGORY_FETCH_FAIL,
  CHILD_CATEGORY_CREATE_INIT, CHILD_CATEGORY_CREATE_SUCCESS, CHILD_CATEGORY_CREATE_FAIL,
  CHILD_CATEGORY_EDIT_INIT, CHILD_CATEGORY_EDIT_SUCCESS, CHILD_CATEGORY_EDIT_FAIL,
  CHILD_CATEGORY_DELETE_INIT, CHILD_CATEGORY_DELETE_SUCCESS, CHILD_CATEGORY_DELETE_FAIL,
  CHILD_CATEGORY_SET,
  CHILD_CATEGORY_CLEAN_UP,
} from 'state/actions/childComponentCategory';

const initialState = {
  list: [],
  category: { _id: '', name: '', description: '' },
  loading: false,
  error: null,
  success: false,
};

export const childComponentCategoryReducer = createReducer(
  {
    [CHILD_CATEGORY_FETCH_INIT]: (state) => ({ ...state, loading: true, error: null }),
    [CHILD_CATEGORY_FETCH_SUCCESS]: (state, payload) => ({ ...state, list: payload.list || [], loading: false, error: null }),
    [CHILD_CATEGORY_FETCH_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error }),
    [CHILD_CATEGORY_CREATE_INIT]: (state) => ({ ...state, loading: true, success: false }),
    [CHILD_CATEGORY_CREATE_SUCCESS]: (state, payload) => ({ ...state, list: state.list.concat(payload.category), loading: false, error: null, success: true }),
    [CHILD_CATEGORY_CREATE_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error, success: false }),
    [CHILD_CATEGORY_EDIT_INIT]: (state) => ({ ...state, loading: true, success: false }),
    [CHILD_CATEGORY_EDIT_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.map((item) => item._id === payload.category._id ? payload.category : item),
      loading: false, error: null, success: true,
    }),
    [CHILD_CATEGORY_EDIT_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error, success: false }),
    [CHILD_CATEGORY_DELETE_INIT]: (state) => ({ ...state, loading: true }),
    [CHILD_CATEGORY_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((item) => item._id !== payload.id),
      loading: false, error: null,
    }),
    [CHILD_CATEGORY_DELETE_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error }),
    [CHILD_CATEGORY_SET]: (state, payload) => ({ ...state, category: payload }),
    [CHILD_CATEGORY_CLEAN_UP]: (state) => ({ ...state, loading: false, error: null, success: false }),
  },
  initialState
);
